import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    onChange: _ctx.onSelectManagerChanged,
    modelValue: _ctx.selectedManagerId,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedManagerId) = $event)),
    placeholder: "Менеджер"
  }, {
    label: _withCtx((scope) => [
      (scope.value == 0)
        ? (_openBlock(), _createBlock(_component_el_text, {
            key: 0,
            type: "info"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" не назначен ")
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_el_text, { key: 1 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.formatSelectedManagerLabel()), 1)
            ]),
            _: 1
          }))
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mngrs, (m) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: m.id,
          value: m.id
        }, {
          default: _withCtx(() => [
            (!m.id)
              ? (_openBlock(), _createBlock(_component_el_text, {
                  key: 0,
                  type: "info"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" не назначен ")
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_text, { key: 1 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(m.lastname) + " " + _toDisplayString(m.firstname ? ` ${m.firstname.substring(0,1)}.` : ''), 1)
                  ]),
                  _: 2
                }, 1024))
          ]),
          _: 2
        }, 1032, ["value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["onChange", "modelValue"]))
}